module.exports = __webpack_public_path__ + "create/static/media/avatar_Rafael.58aefb09.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Institucional/avatar_Rafael.png
// module id = 472
// module chunks = 37